import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_action = _resolveComponent("v-list-item-action")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_combobox = _resolveComponent("v-combobox")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, null, {
        default: _withCtx(() => [
          _cache[4] || (_cache[4] = _createElementVNode("h3", null, "From INRAE's server", -1)),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                class: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_form, {
                    onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => {
              _ctx.handleOpenIco(_ctx.state.fields.projectName);
              _ctx.state.openDialog = false;
            }, ["prevent"]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_combobox, {
                        items: 
                _ctx.recentIcoProjects.map(([key, value]) => ({
                text: value.name,
                value: value}))
              ,
                        "item-text": "text",
                        "item-value": "value",
                        label: "Project name",
                        id: "comboprojectname",
                        autocomplete: "off",
                        "search-input": _ctx.state.fields.projectName,
                        outlined: ""
                      }, {
                        item: _withCtx(({ index, item }) => [
                          _createVNode(_component_v_list_item, {
                            to: _ctx.getHrefFromTypeId({type: item.value.type, id: item.value.id})
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.text), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_spacer),
                              _createVNode(_component_v_list_item_action, {
                                onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_btn, {
                                    icon: "",
                                    onClick: _withModifiers(($event: any) => (
                        _ctx.removeFromRecentProjects(item.value.type, {id: item.value.id})
                      ), ["stop","prevent"])
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, null, {
                                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                                          _createTextVNode("mdi-close")
                                        ])),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _: 1
                      }, 8, ["items", "search-input"]),
                      _createVNode(_component_v_btn, {
                        class: "ml-auto d-flex",
                        color: "secondary",
                        disabled: !_ctx.state.fields.projectName,
                        type: "submit"
                      }, {
                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                          _createTextVNode("Open from Ico")
                        ])),
                        _: 1
                      }, 8, ["disabled"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}